export const billingErrorMappings = {
    BILLING_EMAIL_NOT_AVAILABLE: {
        code: 'BILLING_EMAIL_NOT_AVAILABLE',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Não é possível reenviar o boleto pois o cliente não possui e-mail cadastrado.',
            },
            {
                language: 'pt-BR',
                message: 'Não é possível reenviar o boleto pois o cliente não possui e-mail cadastrado.',
            },
            {
                language: 'en-US',
                message: 'The billing cannot be resent because the client does not have a registered email address.',
            },
            {
                language: 'es-ES',
                message: 'No es posible reenviar el cobro porque el cliente no tiene un correo electrónico registrado.',
            },
        ],
        technicalMessage: 'Customer does not have a registered email address.',
        severity: 'error',
        critical: false,
    },
    BILLING_VALIDATION_DUE_DATE_PAST: {
        code: 'BILLING_VALIDATION_DUE_DATE_PAST',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'A data de vencimento deve ser maior ou igual à data atual.',
            },
            {
                language: 'pt-BR',
                message: 'A data de vencimento deve ser maior ou igual à data atual.',
            },
            {
                language: 'en-US',
                message: 'The due date must be greater than or equal to the current date.',
            },
            {
                language: 'es-ES',
                message: 'La fecha de vencimiento debe ser mayor o igual a la fecha actual.',
            },
        ],
        technicalMessage: 'Data de Vencimento deve ser maior que ou igual',
        severity: 'error',
        critical: false,
    },
    BILLING_VALIDATION_INTEREST_RATE_INVALID: {
        code: 'BILLING_VALIDATION_INTEREST_RATE_INVALID',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'O valor dos juros deve estar entre 0,1% e 100%.',
            },
            {
                language: 'pt-BR',
                message: 'O valor dos juros deve estar entre 0,1% e 100%.',
            },
            {
                language: 'en-US',
                message: 'The interest rate must be between 0.1% and 100%.',
            },
            {
                language: 'es-ES',
                message: 'El valor de los intereses debe estar entre 0,1% y 100%.',
            },
        ],
        technicalMessage: 'O valor dos juros deve estar entre',
        severity: 'error',
        critical: false,
    },
    BILLING_VALIDATION_PAYER_NUMBER_INVALID: {
        code: 'BILLING_VALIDATION_PAYER_NUMBER_INVALID',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'O número do pagador deve ser um número válido.',
            },
            {
                language: 'pt-BR',
                message: 'O número do pagador deve ser um número válido.',
            },
            {
                language: 'en-US',
                message: 'The payer number must be a valid number.',
            },
            {
                language: 'es-ES',
                message: 'El número del pagador debe ser un número válido.',
            },
        ],
        technicalMessage: '"billings[0].payer.number" deve ser um número',
        severity: 'error',
        critical: false,
    },
    BILLING_VALIDATION_ZIPCODE_INVALID: {
        code: 'BILLING_VALIDATION_ZIPCODE_INVALID',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'CEP inválido. Verifique o CEP informado.',
            },
            {
                language: 'pt-BR',
                message: 'CEP inválido. Verifique o CEP informado.',
            },
            {
                language: 'en-US',
                message: 'Invalid ZIP code. Please check the provided ZIP code.',
            },
            {
                language: 'es-ES',
                message: 'Código postal inválido. Verifique el código postal proporcionado.',
            },
        ],
        technicalMessage: 'O CEP',
        severity: 'error',
        critical: false,
    },
    BILLING_VALIDATION_PAYER_ZIPCODE_LENGTH: {
        code: 'BILLING_VALIDATION_PAYER_ZIPCODE_LENGTH',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'CEP do pagador deve ter exatamente 8 caracteres.',
            },
            {
                language: 'pt-BR',
                message: 'CEP do pagador deve ter exatamente 8 caracteres.',
            },
            {
                language: 'en-US',
                message: 'Payer ZIP code must be exactly 8 characters.',
            },
            {
                language: 'es-ES',
                message: 'El código postal del pagador debe tener exactamente 8 caracteres.',
            },
        ],
        technicalMessage: 'CEP do Pagador deve ser de 8 caracteres',
        severity: 'error',
        critical: false,
    },
    BILLING_VALIDATION_ISSUE_DATE_AFTER_DUE_DATE: {
        code: 'BILLING_VALIDATION_ISSUE_DATE_AFTER_DUE_DATE',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'A data de emissão deve ser anterior ou igual à data de vencimento.',
            },
            {
                language: 'pt-BR',
                message: 'A data de emissão deve ser anterior ou igual à data de vencimento.',
            },
            {
                language: 'en-US',
                message: 'The issue date must be before or equal to the due date.',
            },
            {
                language: 'es-ES',
                message: 'La fecha de emisión debe ser anterior o igual a la fecha de vencimiento.',
            },
        ],
        technicalMessage: 'Data de emissão deve ser menor que ou igual a Data de Vencimento',
        severity: 'error',
        critical: false,
    },
    BILLING_VALIDATION_MIN_AMOUNT_AFTER_DISCOUNT: {
        code: 'BILLING_VALIDATION_MIN_AMOUNT_AFTER_DISCOUNT',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'O valor total, após o desconto por pagamento antecipado, não pode ser inferior a R$ 5,00.',
            },
            {
                language: 'pt-BR',
                message: 'O valor total, após o desconto por pagamento antecipado, não pode ser inferior a R$ 5,00.',
            },
            {
                language: 'en-US',
                message: 'The total amount, after early payment discount, cannot be less than R$ 5.00.',
            },
            {
                language: 'es-ES',
                message: 'El valor total, después del descuento por pago anticipado, no puede ser inferior a R$ 5,00.',
            },
        ],
        technicalMessage: 'O valor total, após o desconto por pagamento antecipado, não pode ser inferior a R$ 5,00',
        severity: 'error',
        critical: false,
    },
    BILLING_VALIDATION_PENALTY_RATE_INVALID: {
        code: 'BILLING_VALIDATION_PENALTY_RATE_INVALID',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'O valor da multa deve estar entre 0,1% e 100%.',
            },
            {
                language: 'pt-BR',
                message: 'O valor da multa deve estar entre 0,1% e 100%.',
            },
            {
                language: 'en-US',
                message: 'The penalty rate must be between 0.1% and 100%.',
            },
            {
                language: 'es-ES',
                message: 'El valor de la multa debe estar entre 0,1% y 100%.',
            },
        ],
        technicalMessage: 'O valor da multa deve estar entre 0.1 e 100',
        severity: 'error',
        critical: false,
    },
    BILLING_NOT_FOUND_PIX_KEY: {
        code: 'BILLING_NOT_FOUND_PIX_KEY',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Chave PIX não localizada para a conta informada. Verifique os dados da conta.',
            },
            {
                language: 'pt-BR',
                message: 'Chave PIX não localizada para a conta informada. Verifique os dados da conta.',
            },
            {
                language: 'en-US',
                message: 'PIX key not found for the provided account. Please check the account data.',
            },
            {
                language: 'es-ES',
                message: 'Clave PIX no encontrada para la cuenta proporcionada. Verifique los datos de la cuenta.',
            },
        ],
        technicalMessage: 'Chave pix não localizada para a conta informada',
        severity: 'error',
        critical: false,
    },
    BILLING_NOT_FOUND_CELCOIN_ACCOUNT: {
        code: 'BILLING_NOT_FOUND_CELCOIN_ACCOUNT',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Conta Celcoin não encontrada para o documento informado. Verifique os dados da conta.',
            },
            {
                language: 'pt-BR',
                message: 'Conta Celcoin não encontrada para o documento informado. Verifique os dados da conta.',
            },
            {
                language: 'en-US',
                message: 'Celcoin account not found for the provided document. Please check the account data.',
            },
            {
                language: 'es-ES',
                message: 'Cuenta Celcoin no encontrada para el documento proporcionado. Verifique los datos de la cuenta.',
            },
        ],
        technicalMessage: "Couldn't find celcoin account for document",
        severity: 'error',
        critical: false,
    },
    BILLING_INSTALLMENT_CANCEL_NO_PENDING_PARCELS: {
        code: 'BILLING_INSTALLMENT_CANCEL_NO_PENDING_PARCELS',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Não há parcelas pendentes para cancelar. Todas as parcelas já foram pagas ou canceladas.',
            },
            {
                language: 'pt-BR',
                message: 'Não há parcelas pendentes para cancelar. Todas as parcelas já foram pagas ou canceladas.',
            },
            {
                language: 'en-US',
                message: 'No pending installments to cancel. All installments have already been paid or cancelled.',
            },
            {
                language: 'es-ES',
                message: 'No hay cuotas pendientes para cancelar. Todas las cuotas ya fueron pagadas o canceladas.',
            },
        ],
        technicalMessage: 'Não há parcelas pendentes para cancelar. Todas as parcelas já foram pagas ou canceladas.',
        severity: 'warning',
        critical: false,
    },
    BILLING_NOT_FOUND_RECORD: {
        code: 'BILLING_NOT_FOUND_RECORD',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Cobrança não encontrada. Verifique se a cobrança ainda existe.',
            },
            {
                language: 'pt-BR',
                message: 'Cobrança não encontrada. Verifique se a cobrança ainda existe.',
            },
            {
                language: 'en-US',
                message: 'Billing record not found. Please check if the billing still exists.',
            },
            {
                language: 'es-ES',
                message: 'Cobro no encontrado. Verifique si el cobro aún existe.',
            },
        ],
        technicalMessage: 'Cobrança não encontrada',
        severity: 'error',
        critical: false,
    },
};
